import {
  Component,
  Prop,
  h,
  Event,
  type EventEmitter,
  Listen,
  State,
} from '@stencil/core';
import { getTermsAndConditionsSessionStorageValue } from '../../conversational-search-logic/storage-manager/storage-manager-helpers';
import { onNewConversationClickAction, selectCorrectExitRoute } from './mobile-header-helpers';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

@Component({
  tag: 'uiaas-search-conversational-search-mobile-header',
  styleUrl: 'mobile-header.scss',
  shadow: true,
})
export class ConversationalSearchMobileHeader {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly query: string;
  @Prop() readonly conversationalSearchBrandUrl?: string;
  @Prop() readonly country: string;
  @Prop() readonly language: string;

  @State() areTermsAccepted: boolean;
  @State() isProcessing: boolean;

  @Event({
    eventName: 'conversational-search:user-new-conversation-trigger',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    userStartingNewConversationEventEmitter: EventEmitter;

  @Event({
    eventName: 'conversational-search:ga-icon-action',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    gaIconEventEmitter: EventEmitter<{ actionItem: string; keyword: string, isNotResponseAction: boolean }>;

  @Event({
    eventName: 'conversational-search:chat-visibility',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    chatVisibilityEventEmitter: EventEmitter<{ isChatVisible: boolean }>;

  @Listen('conversational-search:user-start-of-conversation', {
    target: 'window',
  })
  startOfConversationHandler() {
      this.areTermsAccepted = true;
  }

  @Listen('conversational-search:user-question-state', { target: 'window' })
  handleProcessingChange(e) {
      this.isProcessing = e.detail.isProcessing;
  }

  connectedCallback() {
      this.areTermsAccepted = getTermsAndConditionsSessionStorageValue();
  }

  render() {
      const isDisabled = !this.areTermsAccepted || this.isProcessing ? true : void 0;

      return (
        <section class="conversational-search-mobile-header">
          <strong class="conversational-search-mobile-header__text">
            {this.labelProvider('conversational.search.name', 'GenAI Search')}
          </strong>
          <div class="conversational-search-mobile-header__action-items">
            <qds-button
              onClick={() => onNewConversationClickAction(
                this.userStartingNewConversationEventEmitter,
                this.gaIconEventEmitter,
                this.query,
              )}
              importance="subdued"
              icon-name="plus-circle"
              icon-library="default"
              disabled={isDisabled}
            />
            <qds-button
              onClick={() => selectCorrectExitRoute(
                this.gaIconEventEmitter,
                this.chatVisibilityEventEmitter,
                this.conversationalSearchBrandUrl,
                this.query,
                this.country,
                this.language,
              )}
              importance="subdued"
              icon-name="cross-large"
              icon-library="default"
            />
          </div>
        </section>
      );
  }
}
